import { render } from "./RiepilogoProvvigioniRappresentanti.vue?vue&type=template&id=d616e5a4"
import script from "./RiepilogoProvvigioniRappresentanti.vue?vue&type=script&lang=js"
export * from "./RiepilogoProvvigioniRappresentanti.vue?vue&type=script&lang=js"

import "./RiepilogoProvvigioniRappresentanti.vue?vue&type=style&index=0&id=d616e5a4&lang=css"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__